import { useMutation } from "react-query";
import { MutationConfig, queryClient } from "../../../../../lib/react-query";
import { apiEmpleo } from "../../../../../util/ApiEmpleo";
import { candidateAttachmentKeys } from "./candidateAttachments.query-keys";

export type TApiDeleteCandidateAttachmentPayload = {
  candidateId: string;
  attachmentId: string;
};

export const apiDeleteCandidateAttachment = async (
  payload: TApiDeleteCandidateAttachmentPayload
) => {
  await apiEmpleo.delete(
    `candidatos/${payload.candidateId}/attachments/${payload.attachmentId}`
  );
};

type TUseDeleteCandidateAttachmentOptions = {
  config?: MutationConfig<typeof apiDeleteCandidateAttachment>;
};

export const useDeleteCandidateAttachment = ({
  config,
}: TUseDeleteCandidateAttachmentOptions = {}) => {
  return useMutation({
    onSettled: () => {
      queryClient.invalidateQueries(candidateAttachmentKeys.all);
    },
    ...config,
    mutationFn: apiDeleteCandidateAttachment,
  });
};
